<template>
    <div class="rd">
        <div class="pagina">
            <div class="inlog-wrap">
                <form class="paneel inlog-kaart" novalidate @submit.prevent="savePassword">
                    <img src="/x-cube-logo.png" alt="X-Cube" class="inlog-logo" />
                    <h1>Reset password</h1>
                    <p class="muted" style="margin:0 0 8px">Enter your email and we send you a link to set a new password.</p>

                    <div class="veld">
                        <label for="fp-mail">Email</label>
                        <input
                            id="fp-mail"
                            v-model.trim="email"
                            type="email"
                            autocomplete="username"
                            placeholder="you@example.com"
                            :aria-invalid="!!error"
                            @input="error = ''"
                        />
                        <span class="fout">{{ error }}</span>
                    </div>

                    <button class="btn btn-pink" type="submit" style="width:100%" :disabled="loading">
                        {{ loading ? "Sending…" : "Send reset link" }}
                    </button>

                    <div class="inlog-links">
                        <router-link class="linkknop" to="/login">Back to login</router-link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Message } from "element-ui";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { sendResetPasswordEmail } from "../../api/rest";

const router = useRouter();

const email = ref("");
const loading = ref(false);
const error = ref("");

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

const savePassword = async () => {
    error.value = !email.value
        ? "Enter your email address."
        : !EMAIL_RE.test(email.value)
          ? "This email address is missing an @ or a domain."
          : "";
    if (error.value) {
        return;
    }
    try {
        loading.value = true;
        await sendResetPasswordEmail(email.value);
        Message.success("Request sent. Please check your email.");
        router.push("/login");
    } catch (e) {
        console.error(e);
        Message.error("Failed to contact the server, please try again later");
    } finally {
        loading.value = false;
    }
};
</script>
